module.exports = __webpack_public_path__ + "img/france.8b296b78.svg";